// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".set-div[data-v-53464e7a]{padding:0 20px}.set-div .el-form-item__label[data-v-53464e7a]{color:#fff}.operate-div[data-v-53464e7a]{display:flex;align-items:center;justify-content:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
